// extracted by mini-css-extract-plugin
module.exports = {"checkboxesBlock":"styles_checkboxesBlock__20CQ_","disabled":"styles_disabled__3ELl3","checkboxWrap":"styles_checkboxWrap__14tOk","tagStyle":"styles_tagStyle__2etcb"};